import React from 'react';
import ChatHeaderPresenter from './ChatHeaderPresenter';
import AppConfig from '@config';
import {
  CapaQuotationPartnerStrategy,
  CapaQuotationPartnerStatus,
  useFetchWithdrawnQuotationPartnerQuery
} from '@generated/graphql';

import { useSelector } from '@store';

interface Props {
  matches: boolean;
}

const ChatHeaderContainer = ({ matches }: Props) => {
  const partnerId = useSelector((state) => state.chat.quotationPartnerId);

  const { data } = useFetchWithdrawnQuotationPartnerQuery({
    variables: {
      quotationPartnerId: partnerId ?? ''
    },
    skip: !partnerId,
    fetchPolicy: 'cache-first'
  });

  const partner = data?.fetchWithdrawnQuotationPartner.data;

  const isWithdraw = partner?.status === CapaQuotationPartnerStatus.Deleted;

  const onHandlePartnerInfo = () => {
    if (isWithdraw) return;

    window.open(`${AppConfig.baseUrl}/companyInfo?partnerId=${partner?.id}`);
  };

  return (
    <>
      <ChatHeaderPresenter
        partner={
          !data
            ? undefined
            : (partner as CapaQuotationPartnerStrategy) ?? undefined
        }
        matches={matches}
        onHandlePartnerInfo={onHandlePartnerInfo}
      />
    </>
  );
};

export default ChatHeaderContainer;
